import React from 'react';
import { Link } from 'react-router-dom';

export interface DescriptionSegment {
    type: 'text' | 'link' | 'internalLink';
    content: string;
    href?: string;
    path?: string;
    variationId?: number;
}

interface DescriptionProps {
    description: DescriptionSegment[];
}

const DescriptionRenderer: React.FC<DescriptionProps> = ({ description }) => {
    return (
        <p className='noto-sans-regular' style={{ margin: '0px' }}>
            {description.map((segment, index) => {
                if (segment.type === 'link') {
                    return (
                        <a
                            key={index}
                            href={segment.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'underline' }}
                        >
                            {segment.content}
                        </a>
                    );
                } else if (segment.type === 'internalLink') {
                    const path = segment.variationId
                        ? `${segment.path}/${segment.variationId}`
                        : segment.path;

                    return (
                        <Link
                            key={index}
                            to={path!}
                            target="_blank"
                            style={{ textDecoration: 'underline' }}
                        >
                            {segment.content}
                        </Link>
                    );
                } else {
                    return segment.content.split('\n').map((line, lineIndex) => (
                        <React.Fragment key={`${index}-${lineIndex}`}>
                            {line}
                            {lineIndex < segment.content.split('\n').length - 1 && <br />}
                        </React.Fragment>
                    ));
                }
            })}
        </p>
    );
};

export default DescriptionRenderer;
